import { Stack, SxProps, Theme } from "@mui/material";

import { VehicleVisualModelDto } from "@/core/api/generated/v1";

import { DamagePointsVisualizer } from "./DamagePointsVisualizer";

interface Props {
  visualModel: VehicleVisualModelDto;
  imageContainerSx?: SxProps<Theme>;
}

/** @deprecated Use latest version. */
export function VisualModelImagesList({ visualModel, imageContainerSx }: Props) {
  return (
    <>
      <Stack direction='row' spacing={2} sx={{ flexWrap: "wrap" }}>
        {visualModel.images?.map((image, i) => (
          <DamagePointsVisualizer
            key={i}
            pointsInfo={[]}
            imageUrl={image.file?.url}
            containerSx={imageContainerSx}
          />
        ))}
      </Stack>
    </>
  );
}
